<template>
    <div id="admin_container" class="wrapper">
        <i class="fas fa-cog settings-icon" @click="darkMode"></i>
        <loadingSpinner v-if="loading" />
        
        <h1>Admin</h1>
        
        <div class="importing-records" v-if="importDialog">
            <div class="importing-records-container">
                <div v-if="importCounter == recordsList.length && importCounter != 0">
                    <p>Alla skivor inlagda</p>
                    <button @click="closeImportDialog">Fortsätt »</button>
                </div>
                <div v-else>
                    <loadingSpinnerSmall />
                    Lägger in skivor: <br />
                    {{ importCounter }} av {{ recordsList.length }}
                </div>
            </div>
        </div>

        <button v-if="records.length === 0" @click="getRecords">Lägg in skivor</button>
        <button v-if="records.length > 0" class="danger" @click="emptyRecords">Ta bort alla skivor</button>
        <select v-model="traderaUser" @change="selectTraderaUser(traderaUser)">
            <option disabled>Välj Traderaanvändare</option>
            <option value="toppare">Toppare</option>
            <option value="laucer">Laucer</option>
        </select>
        <ul>
            <li class="record-row">
                <span class="col-thumb">&nbsp;</span>
                <span class="col-1"><strong>#</strong></span>
                <span class="col-2"><strong>Namn</strong></span>
                <span><strong>Två sidor</strong></span>
                <span></span>
            </li>
            <li v-if="!records.length" class="record-row" style="justify-content: center;">
                <p>Inga skivor inlagda..</p>
            </li>
            <li class="record-row" v-for="record in records" :key=record.id>
                <span class="col-thumb"><img :src="record.thumb"></span>
                <span class="col-1">{{ record.songNumber }}</span>
                <span class="col-2"><input type="text" @blur="updateTextField($event, record.id)" :value="record.title" /></span>
                <span><input type="checkbox" :id="'switch' + record.id" :checked="record.twoSides" @change="updateSwitch($event, record.id)" /><label :for="'switch' + record.id">Toggle</label></span>
                <span class="col-delete" @click="deleteRecord(record.id)"><i class="fas fa-minus-circle"></i></span>
            </li>
        </ul>
    </div>
</template>

<script>
import db from '@/Firebase/init'
import draggable from 'vuedraggable'
import loadingSpinner from '@/components/LoadingSpinner'
import axios from 'axios'
import loadingSpinnerSmall from '@/components/LoadSpinnerSmall'
import firebase from 'firebase'
import 'firebase/functions'

export default {
    name: 'admin',

    components: {
        draggable,
        loadingSpinner,
        loadingSpinnerSmall
    },

    data() {
        return {
            loading: true,
            darkModeStatus: false,
            records: [],
            currentTitle: '',
            currentSides: false,
            recordsList: [],
            importCounter: 0,
            deletedCounter: 0,
            currentRecords: 0,
            importDialog: false,
            traderaUser: '',
            importFromTraderaUser: {
                traderaUserId: null,
                traderaToken: null
            }
        }
    },

    created() {

        db.collection('autoRecords').orderBy('order').onSnapshot((snapshot) => {
            this.records = []
            snapshot.forEach(doc => {
                let record = doc.data()
                record.id = doc.id
                this.records.push(record)
            })
            this.loading = false
        })

        db.collection('settings').doc('settings').get()
        .then((doc) => {
            this.darkModeStatus = doc.data().darkMode
            if (doc.data().darkMode == true) {
                document.body.classList.add('dark')
            } 
        })
    },

    updated() { 
        this.currentRecords = this.records.length
    },

    methods: {

        selectTraderaUser(usr) {
            db.collection('traderaUsers').doc(usr).get()
            .then(doc => {
                this.importFromTraderaUser.traderaUserId = doc.data().traderaId
                this.importFromTraderaUser.traderaToken = doc.data().token
            })
        },

        closeImportDialog() {
            this.importDialog = false
            this.importCounter = 0
        },

        logOut() {
            firebase.auth().signOut()
            .then(() => {
                this.$router.push('/login')
            }).cath(error => {
                console.log(error)
            })
        },

        resetImportCounter() {
            this.importCounter = 0
        },

        deleteRecord(id) {
            db.collection('autoRecords').doc(id).delete()
            .then(() => {
                const newRecordsOrder = this.records.map((record, index) => {
                    record.order = index +1

                    db.collection('autoRecords').doc(record.id).update({
                        order: index +1
                    })

                    return record
                })
            }).catch(error => {
                console.log(error)
            })
        },

        updateSwitch(e, id) {
            if(e.target.checked) {
                db.collection('autoRecords').doc(id).update({
                    twoSides: true
                })
            } else {
                db.collection('autoRecords').doc(id).update({
                    twoSides: false
                })
            }
        },

        darkMode() {
            const body = document.body
            body.classList.toggle('dark')
            this.darkModeStatus = !this.darkModeStatus
            db.collection('settings').doc('settings').update({
                darkMode: this.darkModeStatus
            })
        },

        emptyRecords() {
            var gerRecordsNow = this.records.length
            this.importCounter = 0
            this.recordsList = []

            db.collection('autoRecords').get()
            .then((snapshot) => {
                 // When there are no documents left, we are done
                if (snapshot.size == 0) {
                    console.log('ALLA BORTA!');
                }

                // Delete documents in a batch
                var batch = db.batch();
                snapshot.docs.forEach((doc, i) => {
                    if (i < 500) {
                        batch.delete(doc.ref);
                    }
                });
                
                batch.commit().then(() => {
                    console.log('ALLA BORTA!222');
                })
                
                
            })
            .catch( error => {
                console.log(error)
            })
        },

        getRecords() {
            let xmls='<soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">\
            <soap12:Header>\
                <AuthenticationHeader xmlns="http://api.tradera.com">\
                <AppId>1805</AppId>\
                <AppKey>f97eeeca-e041-45d8-888d-4c00b654155f</AppKey>\
                </AuthenticationHeader>\
                <AuthorizationHeader xmlns="http://api.tradera.com">\
                <UserId>' + this.importFromTraderaUser.traderaUserId + '</UserId>\
                <Token>' + this.importFromTraderaUser.traderaToken + '</Token>\
                </AuthorizationHeader>\
                <ConfigurationHeader xmlns="http://api.tradera.com">\
                <Sandbox>0</Sandbox>\
                <MaxResultAge>0</MaxResultAge>\
                </ConfigurationHeader>\
            </soap12:Header>\
            <soap12:Body>\
                <GetSellerItems xmlns="http://api.tradera.com">\
                <categoryId>0</categoryId>\
                <filterActive>Active</filterActive>\
<minEndDate>0001-01-01T00:00:00</minEndDate>\
<maxEndDate>9999-12-31T00:00:00</maxEndDate>\
                <filterItemType>All</filterItemType>\
                </GetSellerItems>\
            </soap12:Body>\
            </soap12:Envelope>';

            console.log(xmls)

            this.importDialog = true
            this.importCounter = 0

            const parseString = require('xml2js').parseString;

            axios.post(`${'https://cors-anywhere.herokuapp.com/'}http://api.tradera.com/v3/RestrictedService.asmx`,
            xmls,
            {headers:
                {'Content-Type': 'text/xml'}
            }).then(res=>{
                        var self = this; 
                        parseString(res.data, function (err, result) {
                            // ItemLink
                            // ShortDescription
                            const listResult = result["soap:Envelope"]["soap:Body"][0].GetSellerItemsResponse[0].GetSellerItemsResult[0].Item

                            listResult.forEach((record, key) => {

                                const songNumberPieces = record.ShortDescription[0].split('.')
                                const songNumber = Number(songNumberPieces[0])

                                const recordResult = {
                                    link: record.ItemLink[0], title: record.ShortDescription[0], songNumber: songNumber, thumb: record.ThumbnailLink[0]
                                }
                                self.recordsList.push(recordResult)
                            })
                        }); 

                        //Add records to databse

                        this.recordsList.forEach((value, index) => {
                            const self = this
                            db.collection('autoRecords').add({
                                order: value.songNumber,
                                title: value.title,
                                link: value.link,
                                songNumber: value.songNumber,
                                twoSides: false,
                                thumb: value.thumb
                            }).then(() => {
                                self.importCounter += 1
                            }).catch(error => {
                                console.log(error)
                            })
                        }) 
            }).catch(err=>{console.log(err)});
        },
    }
}
</script>

<style>
* {
    transition: background 1s;
}
body {
    padding-bottom: 120px;
    font-size: 14px;
}

body.dark {
    background: #1E1E1E;
    color: #fff;
}

.importing-records {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 15px 30px rgba(0, 0, 0, .1);
    width: 100vw;
    min-height: 100vh;
    z-index: 9999;
    background: rgba(0, 0, 0, .85);
}

.importing-records-container {
    background: #ffffff;
    padding: 30px 20px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 250px;
}

button.danger {
    background: red;
    color: #fff;
}

.settings-icon {
    position: fixed;
    top: 20px;
    right: 20px;
}

.record-row .number-input {
    -webkit-appearance: none;
    border: none;
    background: #fff;
}

#create_record_container {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #ffcf3c;
    z-index: 2;
    box-shadow: 0 -1px 10px rgba(0, 0, 0, .2);
}

body.dark #create_record_container {
    background: #000;
}

#create_record_container form {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    box-sizing: border-box;
}

button {
    background: #2ecc71;
    color: #fff;
    border-radius: 3px;
    font-size: 14px;
    padding: 6px 15px 7px;
    border: none;
    margin: 8px 0;
}

ul {
    margin: 0;
    padding: 0;
}

#create_record_container form input {
    border: none;
    margin-left: 10px;
}

#create_record_container form input:hover,
#create_record_container form input:active,
#create_record_container form input:focus {
    box-shadow: 0 3px 3px rgba(0, 0, 0, .05);
    outline: none;
}

input[type=text] {
    padding: 7px 10px;
    border-radius: 5px;
    border: 1px solid #dadada;
    width: 100%;
    box-sizing: border-box;
    font-size: 13px;
}

body.dark input[type=text] {
    background: #555;
    color: #fff;
    border: 1px solid #555;
}

.number-input {
    background: #ffcf3c;
    font-size: 17px;
    -webkit-appearance: none;
}

body.dark .number-input {
    background: #1e1e1e;
    color: #fff;
}

ul {
    list-style: none;
}

.record-row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #dadada;
    padding: 10px;
    transition: .35s;
}

body.dark .record-row {
    border-bottom: 1px solid #555;
}

.col-thumb {
    margin-right: 10px;
    width: 65px;
}

.col-1 {
    width: 50px;
}

.col-2 {
    max-width: 340px;
    width: 100%;
    margin-right: 20px;
}

.col-delete {
    margin-left: auto;
}

.col-delete i {
    opacity: 0;
    transition: .35s;
    color: red;
}

.record-row:hover {
    background: #f1f1f1;
}

body.dark .record-row:hover {
    background: #333;
}

.record-row:hover .col-delete i {
    opacity: 1;
}

/* SWITCH */
input[type=checkbox]{
    position: absolute;
	height: 0;
	width: 0;
	visibility: hidden;
}

label {
	cursor: pointer;
	text-indent: -9999px;
	width: 40px;
	height: 21px;
	background: #e74c3c;
	display: block;
	border-radius: 100px;
	position: relative;
}

label:after {
	content: '';
	position: absolute;
	top: 5px;
	left: 5px;
	width: 12px;
	height: 12px;
	background: #fff;
	border-radius: 90px;
	transition: 0.3s;
}

input:checked + label {
	background: #2ecc71;
}

input:checked + label:after {
	left: calc(100% - 5px);
	transform: translateX(-100%);
}

label:active:after {
	width: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin.vue